import {getData} from './api-base.service'


export const getVideo=(id)=>{
  
    //let url="/Advertisting/GetVideo";
    let url="/VideoAppointment/GetVideoUrl";
    if(id==-1){
      url="/Advertisting/GetVideo";
    }
    let result = getData(url, {
        Id: id
      });
      return result;    
}

export const getVideoData=(id)=>{
  let url="/VideoAppointment/GetVideoData";
  let result = getData(url, {
      Id: id
    });
  return result;    
}

export const getVideoPlayAuth=(videoId)=>{
  let url="/AlibabaCloud/GetVideoPlayAuth";
  let result = getData(url, {
      videoId: videoId
    });
  return result;    
}

export const getStsCredentials=(regionId)=>{
  let url="/AlibabaCloud/GetStsCredentials";
  let result = getData(url, {regionId: regionId});
  return result;    
}


// WEBPACK FOOTER //
// ./src/service/player.service.js